<template>
  <div>
    <Modal
      v-model="WorkflowShow"
      title="配置工作流"
      :closable="false"
      :mask-closable="false"
      @on-visible-change="handleVisibleChange"
    >
      <Form
        :label-width="100"
        label-position="left"
        ref="workflowForm"
        :model="workflowDataCurrent"
        :rules="formValid"
        v-if="workflowDataCurrent"
      >
        <FormItem :label="$t('message.workflow.workflowName')" prop="name">
          <Input
            v-model="workflowDataCurrent.name"
            :placeholder="$t('message.workflow.inputFlowName')"
            :disabled="!workflowDataCurrent.notPublish"
          ></Input>
        </FormItem>
        <FormItem label="优先级" prop="priority">
          <Select
            v-model="workflowDataCurrent.priority"
            placeholder="请选择优先级"
          >
            <Option
              v-for="(item, index) in ['P1', 'P2', 'P3', 'P4', 'P5']"
              :label="item"
              :value="item"
              :key="index"
            />
          </Select>
        </FormItem>
        <FormItem :label="$t('message.workflow.use')" prop="uses">
          <we-tag
            :new-label="$t('message.workflow.addUse')"
            :tag-list="workflowDataCurrent.uses"
            @add-tag="addTag"
            @delete-tag="deleteTag"
          ></we-tag>
        </FormItem>
        <FormItem :label="$t('message.project.product')" prop="product">
          <Input
            v-model="workflowDataCurrent.product"
            :placeholder="$t('message.newConst.enterName')"
          />
        </FormItem>
        <FormItem :label="$t('message.project.appArea')" prop="applicationArea">
          <Select
            v-model="workflowDataCurrent.applicationArea"
            :placeholder="$t('message.project.selectAppArea')"
          >
            <Option
              v-for="(item, index) in applicationAreaMap"
              :label="item"
              :value="index"
              :key="index"
            />
          </Select>
        </FormItem>
        <FormItem :label="$t('message.project.business')" prop="business">
          <we-tag
            :new-label="$t('message.project.addBusiness')"
            :tag-list="workflowDataCurrent.business"
            @add-tag="addBusinessTag"
            @delete-tag="deleteBusinessTag"
          ></we-tag>
        </FormItem>
        <FormItem label="预警用户" prop="warningUserData">
          <Select
            v-model="workflowDataCurrent.warningUserData"
            multiple
            filterable
          >
            <Option v-for="item in userIds" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="预警方式" prop="warningType">
          <CheckboxGroup v-model="workflowDataCurrent.warningType">
            <Checkbox label="email">
              <span>邮件</span>
            </Checkbox>
            <Checkbox label="msg">
              <span>短信</span>
            </Checkbox>
            <Checkbox label="iHaier">
              <span>iHaier</span>
            </Checkbox>
            <Checkbox label="iHaier2">
              <span>iHaier2</span>
            </Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem
          :label="$t('message.workflow.workflowDesc')"
          prop="description"
        >
          <Input
            v-model="workflowDataCurrent.description"
            type="textarea"
            :placeholder="$t('message.workflow.inputWorkflowDesc')"
          ></Input>
        </FormItem>
        <Cron
          :cronData="workflowDataCurrent.cronOutput"
          @updateCron="updateCron"
        ></Cron>
      </Form>
      <!-- 调度配置 -->
      <!-- <ScheduleConfig
        ref="schedule-config"
        :current-cron="workflowDataCurrent.cronOutput || '0 * * ? * *'"
        @change-cron="changeCron"
      ></ScheduleConfig> -->
      <div slot="footer">
        <Button type="text" size="large" @click="Cancel">{{
          $t("message.newConst.cancel")
        }}</Button>
        <Button
          type="primary"
          :disabled="workflowDataCurrent.flowStatus === 0"
          size="large"
          @click="Ok"
          >{{ $t("message.newConst.ok") }}</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import tag from "@dss/js/component/tag/index.vue";
import api from "@dss/js/service/api";
//import ScheduleConfig from "@/component/data-development/schedule-config.vue";
import Cron from "@/component/data-development/corn.vue";
import expandRow from "@dss/js/module/project/module/expandTable.vue";
import { isValidCron } from "cron-validator";
import { transformUserIdToName } from "@/api";

export default {
  components: {
    "we-tag": tag,
    //ScheduleConfig,
    Cron,
    expandRow: expandRow,
  },
  props: {
    workflowData: {
      type: Object,
      default: null,
    },
    addWorkflowShow: {
      type: Boolean,
      default: false,
    },
    actionType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      WorkflowShow: false,
      //新增Crontab表达式
      cronOutput: "",
      originCron: "",
      userIds: [], // 新建窗口中预警用户下拉
      // 预警用户
      warningUserData: [],
      warningType: [],
      applicationAreaMap: [],
      originBusiness: "",
      originUse: "",
    };
  },
  computed: {
    workflowDataCurrent() {
      return this.workflowData || new Object();
    },

    formValid() {
      const validateName = (rule, value, callback) => {
        if (this.actionType == "modify") {
          callback();
          return;
        }
        api.instance
          .get(`/dss/checkFlow?name=${value}&id=${this.workflowData.id}`)
          .then((resp) => {
            if (resp.data.message.indexOf("工作流名不能重复") > -1) {
              callback(new Error("工作流名不能重复"));
            } else {
              callback();
            }
          })
          .catch((error) => {
            console.error(error);
            callback(new Error(error));
          });
      };
      return {
        name: [
          {
            required: true,
            message: this.$t("message.newConst.enterName"),
            trigger: "blur",
          },
          { message: `${this.$t("message.newConst.nameLength")}180`, max: 180 },
          {
            type: "string",
            pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/,
            message: this.$t("message.newConst.validNameDesc"),
            trigger: "blur",
          },
          { validator: validateName, trigger: "blur" },
        ],
        priority: [
          {
            required: true,
            message: "请选择优先级",
            trigger: "change",
          },
        ],
        product: [
          {
            required: true,
            message: this.$t("message.project.selectProduct"),
            trigger: "blur",
          },
        ],
        warningUserData: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "预警用户不能为空~",
            trigger: "change",
          },
        ],
        warningType: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "预警方式不能为空~",
            trigger: "change",
          },
        ],
        description: [
          {
            required: true,
            message: "描述不能为空~",
            trigger: "blur",
          },
        ],
        applicationArea: [
          {
            required: true,
            message: this.$t("message.project.selectAppArea"),
            trigger: "change",
            type: "number",
          },
        ],
        cronOutput: [
          {
            required: true,
            message: "cronOutput不能为空~",
            trigger: "blur",
          },
        ],
      };
    },
  },
  mounted() {
    api.fetch("/dss/listApplicationAreas", "get").then((res) => {
      this.applicationAreaMap = res.applicationAreas;
    });
    api
      .fetch("/acl/all/permission/workspace", "get")
      .then(async (res) => {
        let users = res.data.map((item) => ({
          id: item.user,
          name: item.user,
        }));
        this.userIds = await transformUserIdToName(users, "name");
      })
      .catch((e) => {
        console.error(e);
        this.$Message.error("获取授权用户失败");
      });
  },
  watch: {
    addWorkflowShow(val) {
      this.WorkflowShow = val;
      /* if (!val) {
          this.$refs.workflowForm.resetFields();
      } */
    },
    WorkflowShow(val) {
      if (val) {
        this.originBusiness = this.workflowDataCurrent.business;
        this.originUse = this.workflowDataCurrent.uses;

        // this.cronOutput = this.originCron =
        //   this.workflowDataCurrent.cronOutput || "0 * * ? * *";
      }
      this.$emit("show", val);
    },
  },
  methods: {
    updateCron(val) {
      this.workflowDataCurrent.cronOutput = val;
    },
    Ok() {
      // let cronOutput = this.cronOutput.split(" ");

      // let dayOfWeek = cronOutput[cronOutput.length - 1];

      // if (!isNaN(dayOfWeek)) {
      //   cronOutput[cronOutput.length - 1] = dayOfWeek - 1;
      // }

      // cronOutput = cronOutput.join(" ");

      // if (
      //   !isValidCron(cronOutput, {
      //     seconds: true,
      //     allowBlankDay: true,
      //   })
      // ) {
      //   return this.$Message.warning("请检查表达式的合法性");
      // }
      // console.log(this.workflowDataCurrent);
      this.$refs.workflowForm.validate((valid) => {
        if (valid) {
          this.$emit("confirm", {
            ...this.workflowDataCurrent,
            // // 增加Crontab表达式字段
            // cronOutput: this.cronOutput,
          });

          this.WorkflowShow = false;
        } else {
          this.$Message.warning(this.$t("message.newConst.failedNotice"));
        }
      });
    },
    Cancel() {
      this.WorkflowShow = false;
      this.workflowDataCurrent.uses = this.originBusiness;
      this.workflowDataCurrent.business = this.originUse;
      // this.cronOutput = this.originCron;
    },
    addTag(label) {
      if (this.workflowDataCurrent.uses) {
        this.workflowDataCurrent.uses += `,${label}`;
      } else {
        this.workflowDataCurrent.uses = label;
      }
    },
    deleteTag(label) {
      const tmpArr = this.workflowDataCurrent.uses.split(",");
      const index = tmpArr.findIndex((item) => item === label);
      tmpArr.splice(index, 1);
      this.workflowData.uses = tmpArr.toString();
    },

    addBusinessTag(label) {
      if (this.workflowDataCurrent.business) {
        this.workflowDataCurrent.business += `,${label}`;
      } else {
        this.workflowDataCurrent.business = label;
      }
    },
    deleteBusinessTag(label) {
      const tmpArr = this.workflowDataCurrent.business.split(",");
      const index = tmpArr.findIndex((item) => item === label);
      tmpArr.splice(index, 1);
      this.workflowData.business = tmpArr.toString();
    },
    changeCron(value) {
      this.cronOutput = value;
    },
    handleVisibleChange() {
      let { WorkflowShow, workflowDataCurrent } = this;

      // if (WorkflowShow) {
      //   this.$refs["schedule-config"].updateCron(
      //     workflowDataCurrent.cronOutput || "0 * * ? * *"
      //   );
      // }
    },
  },
};
</script>
<style >
.tblUptPadding .ivu-table-cell {
  padding-left: 8px;
  padding-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  box-sizing: border-box;
}
.a-margin-right {
  margin-right: 5px;
}
.tblUptPadding td.ivu-table-expanded-cell {
  padding: 8px 20px;
  background: #f8f8f9;
}
</style>
